module.exports = __webpack_public_path__ + "media/images/gallery/stars/cygnus/deneb_vis-ec2bd902895ce5acce8999c2e78fbdc9.jpg";